import { useTranslations } from '@vocab/react';
import {
  Stack,
  IconCritical,
  Text,
  Columns,
  Column,
} from 'braid-design-system';

import { ApplicationStatus } from 'src/components/ApplicationStatus/ApplicationStatus';
import { ApplicationStatusList } from 'src/components/ApplicationStatus/ApplicationStatusList';
import type { AppliedJobEvent } from 'src/types/graphql';

import translations from './MetaDataApplied.vocab';

interface Props {
  isActive: boolean;
  isExternal: boolean;
  className?: string;
  appliedDate: string;
  appliedDateHiddenVisually: string;
  events: AppliedJobEvent[];
}
// TODO: remove props from redux (applied job events)
export const MetaDataApplied = ({
  isActive,
  isExternal,
  appliedDate,
  appliedDateHiddenVisually,
  events,
}: Props) => {
  const { t } = useTranslations(translations);

  const expiredStatus = (
    <Columns space="xxsmall">
      <Column width="content">
        <Text tone="critical">
          <IconCritical />
        </Text>
      </Column>
      <Column>
        <Text tone="critical">{t('This job is')}</Text>
      </Column>
    </Columns>
  );

  if (isExternal) {
    return (
      <Stack space="large">
        <ApplicationStatus
          label={t('Applied off')}
          tone="positive"
          date={appliedDate}
          dateUtc={appliedDateHiddenVisually}
          desc={t('We wont get')}
        />
        {!isActive ? expiredStatus : null}
      </Stack>
    );
  }

  return (
    <Stack space="medium">
      <ApplicationStatusList events={events} />
      {!isActive ? expiredStatus : null}
    </Stack>
  );
};
